<template>
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M256 810.666667c0 47.146667 38.186667 85.333333 85.333333 85.333333h341.333334c47.146667 0 85.333333-38.186667 85.333333-85.333333V298.666667H256v512zM810.666667 170.666667h-149.333334l-42.666666-42.666667H405.333333l-42.666666 42.666667h-149.333334v85.333333h597.333334V170.666667z"  />
  </svg>
</template>
<script>
  export default {
  }
</script>